// extracted by mini-css-extract-plugin
export default {"root":"Form_root__B8z+M","header":"Form_header__XJ5I6","content":"Form_content__Y7ptS"};